import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const LegalNotice = () => {
  const { language } = useLanguage();

  return (
    <div>
      {/* Hero Section */}
      <section className="section-padding" style={{ background: 'var(--bg-secondary)' }}>
        <div className="container" style={{ textAlign: 'center' }}>
          <h1 className="hero-large" style={{ marginBottom: '16px' }}>
            {language === 'fr' ? 'Mentions légales' : 'Legal Notice'}
          </h1>
        </div>
      </section>

      {/* Content Section */}
      <section className="section-padding">
        <div className="container" style={{ maxWidth: '1000px' }}>
          
          {/* Privacy Policy */}
          <div style={{ marginBottom: '80px' }}>
            <h2 className="hero-medium" style={{ marginBottom: '24px' }}>
              POLITIQUE DE CONFIDENTIALITE – JSX et HENRY AND GABY
            </h2>
            
            <p className="body-regular" style={{ marginBottom: '24px', lineHeight: 1.8 }}>
              JSX et HENRY AND GABY ("nous", "notre") respecte votre vie privée et s'engage à protéger vos renseignements personnels identifiables. Nous avons adopté la présente politique de confidentialité afin d'expliquer quelles informations peuvent être recueillies sur ce site Web ("Site") et comment ces renseignements peuvent être utilisés et/ou partagés avec d'autres. Cette politique de confidentialité est soumise aux Conditions d'utilisation affichées sur ce site ("Conditions Générales d'Utilisations du site"). Toute modification concernant cette politique de confidentialité, les informations légales ou les Conditions générales d'utilisation du site seront effectives immédiatement après leur dépôt révisé sur ce site. Nous vous conseillons leurs consultations avant toute utilisation du site. Toutes ces conditions sont considérées acceptées et connues de tout internaute utilisant le site Internet.
            </p>

            {/* Section 1 */}
            <div style={{ marginBottom: '32px' }}>
              <h3 className="heading-1" style={{ marginBottom: '16px' }}>
                1. Vos informations et comment nous les utilisons
              </h3>
              <p className="body-regular" style={{ marginBottom: '16px', lineHeight: 1.8, color: 'var(--text-secondary)' }}>
                Ce site recueille deux types d'informations : (1) les informations permettant de vous identifier personnellement (comme votre nom et votre adresse e-mail), et (2) l'information qui ne permettent pas de vous identifier (tels que le nombre d'utilisateurs qui se connectent au site sur une base quotidienne). En général, aucune information personnellement identifiable n'est automatiquement collectée à partir de votre visite sur ce site. Toutefois, dans certaines circonstances, il peut vous être demandé de nous fournir certaines informations vous concernant.
              </p>
              <p className="body-regular" style={{ marginBottom: '16px', lineHeight: 1.8, color: 'var(--text-secondary)' }}>
                L'information personnellement identifiable que vous soumettrez sera utilisée pour donner suite à vos demandes et répondre à vos questions. Il pourra également être utilisé par nous ou parents respectifs, filiales, sociétés affiliées, associés, les commanditaires et les partenaires, qui nous permettent de vous fournir produits et/ou services.
              </p>
            </div>

            {/* Section 2 */}
            <div style={{ marginBottom: '32px' }}>
              <h3 className="heading-1" style={{ marginBottom: '16px' }}>
                2. Cookies
              </h3>
              <p className="body-regular" style={{ marginBottom: '16px', lineHeight: 1.8, color: 'var(--text-secondary)' }}>
                Les "cookies" sont de petits fichiers texte d'un site Web qui sont stockés sur votre disque dur. Ces petits fichiers texte permettant de rendre l'exploitation d'un site Internet plus pratique en enregistrant par exemple vos mots de passe et vos préférences. Les cookies eux-mêmes ne contiennent aucune information personnelle identifiable.
              </p>
            </div>

            {/* Section 3 */}
            <div style={{ marginBottom: '32px' }}>
              <h3 className="heading-1" style={{ marginBottom: '16px' }}>
                3. Maintien de la sécurité de vos informations
              </h3>
              <p className="body-regular" style={{ marginBottom: '16px', lineHeight: 1.8, color: 'var(--text-secondary)' }}>
                Assurer la confidentialité de vos informations personnelles identifiables sécurisée est l'une de nos plus importantes responsabilités. Nous apprécions votre confiance et gérerons les informations d'identification personnelle avec soin. Nous protégeons ces renseignements conformément aux normes de sécurité établies et des procédures, et surveillons continuellement les nouveautés technologiques en matière de protection des informations.
              </p>
            </div>

            {/* Section 4 */}
            <div style={{ marginBottom: '32px' }}>
              <h3 className="heading-1" style={{ marginBottom: '16px' }}>
                4. Garder vos informations à jour
              </h3>
              <p className="body-regular" style={{ marginBottom: '16px', lineHeight: 1.8, color: 'var(--text-secondary)' }}>
                Garder des informations personnellement identifiables à jour est très important. Si jamais vous trouvez que les informations vous concernant sont incomplètes, inexactes ou non actuelles, nous souhaiterions les corriger. Merci de nous contacter par le biais de l'un des mécanismes énumérés ci-dessous.
              </p>
              <p className="body-regular" style={{ marginBottom: '16px', lineHeight: 1.8, color: 'var(--text-secondary)' }}>
                <strong>Politique de la vie privée des enfants :</strong> Notre site ne fait pas sciemment la collecte d'informations auprès d'enfants de moins de 13 ans. Si vous avez moins de 13 ans, s'il vous plaît ne nous donnez pas d'informations personnelles.
              </p>
            </div>

            {/* Section 5 */}
            <div style={{ marginBottom: '32px' }}>
              <h3 className="heading-1" style={{ marginBottom: '16px' }}>
                5. Transfert d'actifs
              </h3>
              <p className="body-regular" style={{ marginBottom: '16px', lineHeight: 1.8, color: 'var(--text-secondary)' }}>
                Alors que nous continuons à développer nos affaires, nous pourrions vendre ou acheter des biens. Si une autre entité acquiert la totalité ou la quasi-totalité de nos actifs, les informations d'identification personnelle, des informations non personnelles, et toute autre information que nous avons recueillis sur les utilisateurs du site seront transférés à cette entité comme l'un des actifs transférés.
              </p>
            </div>

            {/* Section 6 */}
            <div style={{ marginBottom: '32px' }}>
              <h3 className="heading-1" style={{ marginBottom: '16px' }}>
                6. Autres sites
              </h3>
              <p className="body-regular" style={{ marginBottom: '16px', lineHeight: 1.8, color: 'var(--text-secondary)' }}>
                Ce Site peut contenir des liens vers d'autres sites Web dans un but d'information de l'internaute sur des sites pouvant avoir un rapport aux services aux entreprises. Ces sites ne sont pas contrôlés ni maintenus par nous, et nous ne sommes pas responsables des pratiques employées par ces autres sites web. Cette politique de confidentialité s'applique uniquement aux informations collectées par le biais de ce site.
              </p>
            </div>

            {/* Section 7 */}
            <div style={{ marginBottom: '32px' }}>
              <h3 className="heading-1" style={{ marginBottom: '16px' }}>
                7. Contactez-nous
              </h3>
              <p className="body-regular" style={{ marginBottom: '16px', lineHeight: 1.8, color: 'var(--text-secondary)' }}>
                Si vous avez des questions ou des commentaires concernant nos pratiques en matière de confidentialité, ou si vous désirez revoir ou modifier toute information personnellement identifiable que vous nous avez fourni, vous pouvez nous contacter :
              </p>
              <p className="body-regular" style={{ marginBottom: '8px', lineHeight: 1.8, color: 'var(--text-primary)' }}>
                <strong>Email :</strong> contact@henry-and-gaby.com
              </p>
              <p className="body-regular" style={{ marginBottom: '16px', lineHeight: 1.8, color: 'var(--text-primary)' }}>
                <strong>Adresse :</strong> 20 rue des Capucins, 77160 PROVINS, France
              </p>
            </div>
          </div>

          {/* Legal Information */}
          <div style={{ 
            marginBottom: '80px',
            padding: '40px',
            background: 'var(--bg-secondary)',
            border: '1px solid var(--border-light)'
          }}>
            <h2 className="hero-medium" style={{ marginBottom: '24px' }}>
              INFORMATIONS LÉGALES
            </h2>
            
            <div style={{ marginBottom: '24px' }}>
              <h3 className="heading-2" style={{ marginBottom: '12px' }}>
                Propriétaire du site
              </h3>
              <p className="body-regular" style={{ lineHeight: 1.8, color: 'var(--text-secondary)' }}>
                EI JEROME SERRE<br />
                20 rue des Capucins<br />
                77160 PROVINS<br />
                France<br />
                www.henry-and-gaby.com
              </p>
            </div>

            <div style={{ marginBottom: '24px' }}>
              <h3 className="heading-2" style={{ marginBottom: '12px' }}>
                Directeur de publication
              </h3>
              <p className="body-regular" style={{ lineHeight: 1.8, color: 'var(--text-secondary)' }}>
                Jérôme-Henri SERRE
              </p>
            </div>

            <div style={{ marginBottom: '24px' }}>
              <h3 className="heading-2" style={{ marginBottom: '12px' }}>
                Siège social
              </h3>
              <p className="body-regular" style={{ lineHeight: 1.8, color: 'var(--text-secondary)' }}>
                20 rue des Capucins<br />
                77160 PROVINS<br />
                France
              </p>
            </div>

            <div style={{ marginBottom: '24px' }}>
              <p className="body-regular" style={{ lineHeight: 1.8, color: 'var(--text-secondary)' }}>
                <strong>N° TVA Intra. :</strong> FR 96441777992<br />
                <strong>SIRET :</strong> 441 777 992 00039
              </p>
            </div>

            <div style={{ marginBottom: '24px' }}>
              <h3 className="heading-2" style={{ marginBottom: '12px' }}>
                Serveur, Développement & Intégration
              </h3>
              <p className="body-regular" style={{ lineHeight: 1.8, color: 'var(--text-secondary)' }}>
                OVH
              </p>
            </div>

            <div>
              <h3 className="heading-2" style={{ marginBottom: '12px' }}>
                Images
              </h3>
              <p className="body-regular" style={{ lineHeight: 1.8, color: 'var(--text-secondary)' }}>
                Libre de droits & propriété gérée par JSX HENRY AND GABY
              </p>
            </div>
          </div>

          {/* Terms of Use */}
          <div>
            <h2 className="hero-medium" style={{ marginBottom: '24px' }}>
              CONDITIONS GÉNÉRALES D'UTILISATION DU SITE
            </h2>

            <div style={{ marginBottom: '32px' }}>
              <h3 className="heading-1" style={{ marginBottom: '16px' }}>
                Juridiction
              </h3>
              <p className="body-regular" style={{ marginBottom: '16px', lineHeight: 1.8, color: 'var(--text-secondary)' }}>
                Ce site est soumis au droit Français.
              </p>
            </div>

            <div style={{ marginBottom: '32px' }}>
              <h3 className="heading-1" style={{ marginBottom: '16px' }}>
                Propriété intellectuelle
              </h3>
              <p className="body-regular" style={{ marginBottom: '16px', lineHeight: 1.8, color: 'var(--text-secondary)' }}>
                Tous les éléments du présent site notamment les marques déposées, noms de domaine, textes, graphismes, logos, animations, etc. sont la propriété de l'éditeur de ce site. Par conséquent, toute reproduction ou utilisation non autorisée de tout ou partie des éléments et informations de ce site est interdite sans l'autorisation préalable de HENRY AND GABY.
              </p>
            </div>

            <div style={{ marginBottom: '32px' }}>
              <h3 className="heading-1" style={{ marginBottom: '16px' }}>
                Informations diffusées
              </h3>
              <p className="body-regular" style={{ marginBottom: '16px', lineHeight: 1.8, color: 'var(--text-secondary)' }}>
                Malgré tout le soin apporté au traitement des informations diffusées sur ce site, HENRY AND GABY ne saurait être tenue pour responsable des erreurs ou omissions dans ces informations, de l'interprétation des informations diffusées, ni des conséquences de leur utilisation.
              </p>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
};

export default LegalNotice;
